import { sample } from "lodash";
import { faker } from "@faker-js/faker";

export const mockCircles = [...Array(24)].map((_, index) => ({
  id: faker.string.uuid(),
  avatarUrl: `/assets/images/avatars/avatar_${index + 1}.jpg`,
  circleLeaderName: faker.person.fullName(),
  circleName: faker.company.name(),
  isVerified: faker.datatype.boolean(),
  status: sample(["active", "banned"]),
  amount: faker.finance.amount(10, 999, 2),
  totalMembers: faker.number.int({ min: 5, max: 999 }),
  currentTotalMemberContributions: faker.finance.amount(10, 999, 2),
}));

export const mockCircleMembers = [...Array(15)].map((_, index) => ({
  id: faker.string.uuid(),
  avatarUrl: `/assets/images/avatars/avatar_${index + 1}.jpg`,
  isVerified: faker.datatype.boolean(),
  amount: faker.finance.amount(10, 999, 2),
  memberContributed: sample(["Yes", "No"]),
  memberName: faker.person.fullName(),
}));
